export const UPDATE_USER_PHONE_START = 'UPDATE_USER_PHONE_START';
export const UPDATE_USER_PHONE_SUCCESS = 'UPDATE_USER_PHONE_SUCCESS';
export const UPDATE_USER_PHONE_ERROR = 'UPDATE_USER_PHONE_ERROR';
export const UPDATE_USER_PHONE_END = 'UPDATE_USER_PHONE_END';
